import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../store/user/action";
import male from "../assets/images/male.png";
import { CreatorDetails } from "../component/dialog/CreatorDetails";
import { useNavigate } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const T = {
  pageBg: "var(--mx-bg)",
  text: "var(--mx-text)",
  sub: "var(--mx-text-2)",
  border: "var(--mx-border)",
  card: "var(--mx-card)",
  cardSolid: "var(--mx-veil)",
  radius: 16,
  shadow: "var(--mx-shadow-float)",
  // accents
  indigo: "var(--mx-accent)",
  purple: "var(--mx-accent)",
  green: "var(--mx-ok)",
  rose: "var(--mx-pink)",
  // grad* entries render flat (a same-color two-stop gradient); names kept for callers
  gradIndigo: "var(--mx-accent)",
  gradPink: "var(--mx-pink)",
  gradBlue: "var(--mx-info)",
  gradPurple: "var(--mx-accent)",
  gradPink2: "var(--mx-pink)",
  gradepurple2: "var(--mx-card)",
};

const Creators = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    dispatch(getUser(agencyId));
  }, [dispatch, agencyId]);

  const handleOpenHostHistory = (id) => {
    navigate("/agencypanel/hosthistory", { state: id });
  };

  return (
    <>
      <div
        class="page-container"
        style={{
          background: "var(--mx-bg)",
        }}
      >
        <div class="page">
          <div class="main-wrapper ps-0">
            <div className="main-section">
              {/* Top Bar */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 9,
                  background: "var(--mx-bg)",
                  padding: "14px 12px",
                  borderBottom: `1px solid ${T.border}`,
                  backdropFilter: "blur(10px)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div>
                    <div
                      style={{ fontWeight: 500, fontSize: 18, color: T.text }}
                    >
                      {t("host")}
                    </div>
                    <div style={{ fontSize: 12, color: T.sub, marginTop: 2 }}>
                      {t("manage_agency_view")}
                    </div>
                  </div>
                </div>
              </div>

              <CreatorDetails />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Creators;
